
import { Shield, Bot, MessageSquare, Users, Crown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

const featuresData = [
  {
    icon: <Shield className="w-8 h-8 text-fembot-pink" />,
    title: "Powerful Moderation",
    description: "Effectively manage your server with advanced moderation tools including auto-mod, warning system, and customizable responses.",
    link: "/moderation"
  },
  {
    icon: <Bot className="w-8 h-8 text-fembot-pink" />,
    title: "AI Capabilities",
    description: "Leverage advanced AI for conversation and smart responses (available with premium tiers).",
    link: "/ai-features",
    premium: true
  },
  {
    icon: <MessageSquare className="w-8 h-8 text-fembot-pink" />,
    title: "Engagement Tools",
    description: "Keep your server active with polls, rock paper scissors game, and fun interaction commands like hug, kiss, and snuggle.",
    link: "/engagement",
    premium: true
  },
  {
    icon: <Shield className="w-8 h-8 text-fembot-pink" />,
    title: "Security Tools",
    description: "Protect your server with raid protection, verification systems, and anti-phishing measures.",
    link: "/security-tools"
  }
];

const Features = () => {
  return (
    <section className="py-20 bg-white dark:bg-gray-900">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 dark:text-white">
            Packed with Powerful Features
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Everything you need to create an engaging and well-managed Discord community
          </p>
          <p className="text-sm text-fembot-pink mt-3 italic">
            Some features are still in development and may not be available at this point in time
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {featuresData.map((feature, index) => (
            <div 
              key={index}
              className="bg-gray-50 dark:bg-gray-800 p-8 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 card-hover relative overflow-visible"
            >
              {feature.premium && (
                <div className="absolute -top-3 -right-3 z-10">
                  <div className="inline-flex items-center p-1.5 rounded-full bg-gradient-to-r from-yellow-400 to-amber-600">
                    <div className="bg-gray-50 dark:bg-gray-800 rounded-full px-3 py-1">
                      <div className="flex items-center space-x-1 rounded-full text-xs font-semibold text-amber-700 dark:text-amber-400">
                        <Crown className="h-3 w-3" />
                        <span>Premium</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="bg-pink-50 dark:bg-gray-700 p-3 rounded-lg inline-block mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3 dark:text-white">{feature.title}</h3>
              <p className="text-gray-600 dark:text-gray-400 mb-4">{feature.description}</p>
              <Link to={feature.link}>
                <Button 
                  className="mt-2 bg-fembot-pink hover:bg-fembot-dark-pink text-white" 
                >
                  Learn More
                </Button>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
